module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3461593.8b2fd4f8.png";